import Renderer from "../Renderer";
import { sanitizeHtml } from "./sanitizeHtml";

export default class NotificationBar {
    static showNotification(text, type) {
        let template = document.getElementById("HB-notification");
        if (!template) {
            console.error("MAGLR ERROR: Notification template not found");
        }
        let id = Date.now();
        const html = Renderer.renderSource(template.innerHTML, {
            text: text,
            type: type,
            identifier: id,
        });

        const container = document.getElementById("maglr-notification-bar");
        const wrapper = document.createElement("div");
        wrapper.setAttribute("id", `notificationWrapper-${id}`);
        wrapper.classList.add("notificationWrapper");
        wrapper.innerHTML = sanitizeHtml(html);
        container.appendChild(wrapper);
        container
            .querySelector(`[data-closenotification='${id}']`)
            .addEventListener("click", NotificationBar.closeNotification);
    }

    static closeNotification(e) {
        const bar = e.target.parentNode;
        bar.classList.add("out");
        setTimeout(() => {
            bar.parentNode.removeChild(bar);
        }, 300);
    }
}
